module.exports = __webpack_public_path__ + "static/media/090-burkina-faso.360e7d89.svg";